import { render, staticRenderFns } from "./UserSignup.vue?vue&type=template&id=59685c08&"
import script from "./UserSignup.vue?vue&type=script&lang=js&"
export * from "./UserSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports